// composables/useClipboardWithToast.ts
import { ref } from 'vue'

export const useClipboardWithToast = () => {
  // Only initialize these when the composable is actually used in a component
  let toast: ReturnType<typeof useToast>
  let clipboardState: ReturnType<typeof useClipboard>

  // Initialize a ref to track if the composable is ready
  const isReady = ref(false)

  // Function to ensure initialization happens in the correct lifecycle
  const initialize = () => {
    if (!isReady.value) {
      toast = useToast()
      clipboardState = useClipboard()
      isReady.value = true
    }
  }

  const copy_w_toast = (value: string) => {
    // Ensure initialization before using
    initialize()
    
    clipboardState.copy(value)
    toast.add({
      color: 'green',
      title: `${value} (cкопировано)`,
    })
  }

  return {
    copy_w_toast,
    // Getter functions that ensure initialization
    get text() {
      initialize()
      return clipboardState.text
    },
    get copied() {
      initialize()
      return clipboardState.copied
    },
    get isSupported() {
      initialize()
      return clipboardState.isSupported
    }
  }
}

// Usage example in a component:
/*
<script setup>
const clipboard = useClipboardWithToast()

const handleCopy = () => {
  clipboard.copyWithToast('Text to copy')
}
</script>
*/